import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Lead } from 'types'

interface UpdateLeadParams {
  lead_uuid: string
  updates: Partial<Lead>
}

const updateLead = async ({ lead_uuid, updates }: UpdateLeadParams): Promise<Lead> => {
  const url = `${baseUrl}/aws/update/leads/${lead_uuid}`
  try {
    const response = await axios.put<Lead>(url, updates)
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update lead:', error)
    throw error
  }
}

export const useUpdateLead = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateLead,
    onSuccess: updatedLead => {
      // Invalidate and refetch the leads query
      queryClient.invalidateQueries({ queryKey: ['leads'] })

      // Optionally update the cache directly for immediate UI update
      queryClient.setQueryData(['leads'], (oldData: Lead[] | undefined) => {
        if (!oldData) return oldData
        return oldData.map(lead => (lead.lead_uuid === updatedLead.lead_uuid ? updatedLead : lead))
      })
    },
    onError: error => {
      console.error('[useUpdateLead] Error updating lead:', error)
    },
  })
}
